import { AllowedPaymentMethodsClient } from "../../../../../../../../Wrap/Api/Pension/Payments/AllowedPaymentMethods";
import { PaymentSubType } from "../../../../../../../../Wrap/Constants/Enums/Pension/Payments/PaymentSubType";
import { AllowedPaymentMethodModel } from "../../../../../../../../Wrap/Models/Models/Pension/Payments/AllowedPaymentMethodModel";

export class AllowedPaymentMethodAction {
    public static GetAllAllowedPaymentMethods(hierarchyId: string, paymentSubType: PaymentSubType, paymentAmount: number | undefined, callback: (val: AllowedPaymentMethodModel[]) => void) {
        const client = new AllowedPaymentMethodsClient();
        client.get(hierarchyId, paymentSubType, paymentAmount).onSuccess((allowedPaymentMethods: AllowedPaymentMethodModel[]) => {
            callback(allowedPaymentMethods);
        });
    }
}
